import {
  UPDATE_ALERT_LIST,
  ALERT_LOG_LIST,
  GET_ALERTLIST,
  ADD_TENANT,
  EDIT_SUBDIVISION_USER,
  SET_ALERT,
  ADD_ALERTCOMMENT,
  RESET_ALERT_COMMENT,
  GET_ALERTLIST_SOCKET,
} from "../../@jumbo/constant/ActionTypes";

const INIT_STATE = {
  users: [],
  alertDetails: null,
  addAlertComment: {},
  logList: {
    logs: [],
    page: 1,
    limit: 10,
    total: 0,
    total_no_of_logs_overall: 0,
  },
};
let finalData;
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ALERTLIST: {
      return {
        ...state,
        users: action.payload,
      };
    }

    case GET_ALERTLIST_SOCKET: {
      let alertLogs = [];
      let currentAlertLogs = state?.users?.alertLogs;
      if (currentAlertLogs && currentAlertLogs.length > 0) {
        alertLogs = currentAlertLogs.filter(
          (alert) => alert.alertId !== action?.payload?.crisisAlert?.alertId
        );
      }
      return {
        ...state,
        users: {
          ...state.users,
          total_alerts: action.payload.alertcount,
          alertLogs: [action?.payload?.crisisAlert, ...alertLogs],
        },
      };
    }

    case ADD_ALERTCOMMENT:
      return {
        ...state,
        addAlertComment: action.payload,
        logList: {
          ...state.logList,
          logs: [action.payload, ...state.logList.logs],
          total: state.logList.total + 1,
          total_no_of_logs_overall: state.logList.total_no_of_logs_overall + 1,
        },
      };

    case RESET_ALERT_COMMENT:
      return {
        ...state,
        addAlertComment: {},
      };
    case SET_ALERT: {
      return {
        ...state,
        alertDetails: action.payload,
      };
    }

    case ADD_TENANT: {
      return {
        ...state,
        users: [action.payload, ...state.users],
      };
    }
    case EDIT_SUBDIVISION_USER: {
      return {
        ...state,
        allUsers: state.allUsers.map((allUsers) =>
          allUsers.id === action.payload._id ? action.payload : allUsers
        ),
      };
    }
    case UPDATE_ALERT_LIST: {
      return {
        ...state,
        users: { ...state.users, ...action?.payload },
      };
    }
    case ALERT_LOG_LIST: {
      return {
        ...state,
        logList: action.payload,
      };
    }

    default:
      return state;
  }
};
